import { FlexRow, Text, Tooltip } from '@epam/promo';
import css from './Tag.module.scss';

const Tag = ({ value, tooltip }: { value: string; tooltip?: string }) => {
  const number = Number(value);

  if (tooltip) {
    return (
      <FlexRow>
        <Tooltip content={tooltip} placement="bottom">
          <Text cx={css.tag}>{value}</Text>
        </Tooltip>
      </FlexRow>
    );
  }

  if (!number || Number.isNaN(number)) {
    return null;
  }

  return <Text cx={css.tag}>{value}</Text>;
};

Tag.defaultProps = {
  tooltip: undefined,
};

export { Tag };
